import { User } from "shared/store/auth/types";

export enum Type {
  global = "global",
  relationProfile = "relationProfile",
}

export interface Message {
  id: number;
  type: Type | "";
  relation_id: number;
  created_at: string;
  user?: User;
}
